import { ComponentType } from "react";
import { ArrowLeft, Home, ShieldAlert } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useNavigationHelpers } from "@/lib/navigation-helpers";
import { usePermissions } from "@/hooks/use-permissions";
import { PermissaoEnum } from "@workflow/types";
import { GuardStatePanel } from "./GuardStatePanel";

export function withPermissionPage<P extends object>(
  Component: ComponentType<P>,
  requiredPermission: PermissaoEnum[],
) {
  return function GuardedPage(props: P) {
    const { goBackOrFallback, goToHome } = useNavigationHelpers();

    const { hasAnyPermission } = usePermissions();

    const handleFallback = () => goBackOrFallback(goToHome);

    if (!hasAnyPermission(requiredPermission)) {
      return (
        <GuardStatePanel
          icon={ShieldAlert}
          title="Acesso Restrito"
          description="Seu perfil de usuário não possui as permissões necessárias para visualizar esta página."
          footer={
            process.env.NODE_ENV === "development" && (
              <div className="mt-4 w-full break-words rounded-md bg-muted/50 p-2 text-center font-mono text-xs text-muted-foreground">
                Required: {requiredPermission.join(" | ")}
              </div>
            )
          }
          actions={
            <>
              <Button
                variant="outline"
                onClick={goToHome}
                className="w-full sm:w-auto sm:min-w-[140px]"
              >
                <Home className="mr-2 h-4 w-4" />
                Ir para a Home
              </Button>
              <Button onClick={handleFallback} className="w-full sm:w-auto sm:min-w-[140px]">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Voltar
              </Button>
            </>
          }
        />
      );
    }

    // 3. Render
    return <Component {...props} />;
  };
}
